var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrnotcontains(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.5,13h-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.5,15V11.5a2.5,2.5,0,0,1,5,0V15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.5,9h5l-5,6h5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.67,4.5H5.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.33,19.5H18.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrnotcontains);
export default __webpack_public_path__ + "static/media/strnotcontains.f6d4af9c.svg";
export { ForwardRef as ReactComponent };